
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[subject]",
      function () {
        return require("private-next-pages/resources/[subject].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[subject]"])
      });
    }
  